const LeftCheckBox = ({ items, values, label, onChange }) => {
  return (
    <div className="rounded-lg bg-white text-base">
      <p className="font-semibold mb-1">{label}</p>

      <div className="grid grid-cols-1 gap-2">
        {items.map((item) => (
          <label key={item} className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={!!values?.[item]}
              onChange={(e) => onChange(item, e.target.checked)}
              className="accent-blue-600 border-2 border-gray-700"
            />
            <span>{item}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default LeftCheckBox;